import { useOnScreen } from '@festina-life/ui/hooks'
import { useEffect, useRef } from 'react'

import { useTemplateContext } from '../../context/templateContext'

export const TemplateFieldAnchor = ({ path }: { path: string }) => {
  const { onUpdateScrollPath } = useTemplateContext()
  const anchorRef = useRef<HTMLAnchorElement>(null)
  const onScreen = useOnScreen(anchorRef)
  const reportedOnScreenForTopOffset = useRef(-1)

  useEffect(() => {
    if (onScreen) {
      const topOffset = anchorRef.current?.getBoundingClientRect().top ?? 0
      if (topOffset !== reportedOnScreenForTopOffset.current) {
        reportedOnScreenForTopOffset.current = topOffset
        onUpdateScrollPath(path)
      }
    }
  }, [onScreen, onUpdateScrollPath, path])

  return <a ref={anchorRef} id={path} />
}
